module.exports = __webpack_public_path__ + "img/screenshot02.788d8fd8.png";